import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })

export class CapitalizePipe implements PipeTransform {
  transform(value: string, args?: Array<any>): any {
    return value.toLowerCase().replace(/([^ -])([^ -]*)/gi, function(v, v1, v2) {
      return v1.toUpperCase() + v2;
    });
  }
}
